import { useNavigate } from "react-router-dom";
import { SOLUTIONS } from "@/data/content";
import Icon from "@/components/Icon";

export default function SolutionsSection() {
  const navigate = useNavigate();
  const go = (key) => navigate(`/solutions/${key}`);

  return (
    <section className="section solutions" id="solutions" data-testid="solutions-section">
      <div className="container">
        <div className="sec-head sec-head--stack">
          <h2 className="sec-head__title">Corporate Solutions<span className="sec-head__rule" /></h2>
          <p className="sec-head__sub">Enterprise tools for a more connected healthcare future.</p>
          <p className="sec-head__lead">From clinical care to operational excellence, Proactive UMS provides integrated solutions that empower providers, payers, employers and communities.</p>
        </div>

        <div className="sol__grid">
          {SOLUTIONS.map((s) => (
            <div
              className="sol__card"
              key={s.key}
              data-testid={`sol-card-${s.key}`}
              onClick={() => go(s.key)}
              role="link"
              tabIndex={0}
              onKeyDown={(e) => (e.key === "Enter" ? go(s.key) : null)}
            >
              <span className="sol__icon"><Icon name={s.icon} size={24} /></span>
              <h3 className="sol__title">{s.title}</h3>
              <p className="sol__text">{s.text}</p>
              <button className="sol__arrow" onClick={(e) => { e.stopPropagation(); go(s.key); }} aria-label={`Learn about ${s.title}`} data-testid={`sol-arrow-${s.key}`}>
                <Icon name="ArrowRight" size={16} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
